export interface IVariableContext {
  componentName: string;
  componentSlug: string;
  index: number;
  precedingCss: string;
  processor: string;
  source: string;
  unit: string;
  valueSlug: string;
}
